<template>
  <div id="lm-menu" ref="sidebarMenu" :class="{ collapsed: !expanded }">
    <template v-if="!isLoading">
      <div class="menu-content">
        <div class="scrollable">
            <router-link to="/" id="lm-logo" class="d-block mx-3 mt-3" :class="{ collapsed: !expanded }">
              <img :src="$store.state.settings.logoImg" alt="Logo">
            </router-link>
            <router-link to="/" id="lm-logo-fav" :class="{ collapsed: !expanded }">
              <img :src="$store.state.settings.faviconDot" alt="Logo">
            </router-link>
          <div class="menu" :class="{ collapsed: !expanded }">
          <label class="menu-label">MENU</label>
          <Component
            v-for="(item, index) of menuItems"
            :key="item.index"
            :to="item.path ? item.path : '/'"
            :is="item.newTab || item.href ? 'a' : 'router-link'"
            :href="item.href ? item.href : ''"
            v-b-popover.hover="popoverConfig(item)"
            v-b-toggle="'collapse' + index"
            class="menu-item"
            :target="item.newTab ? '_blank' : '_self'"
            :class="{ parent: item.parent }"
            @click="onItemClicked(item)"
          >
            <div class="menu-item-content">
              <span class="icon"><i :class="item.icon" /></span>
              <span class="text">{{ item.name }}</span>
            </div>
            <b-collapse
              v-if="item.parent && expanded"
              :id="'collapse' + index"
              class="children-menu-items"
            >
              <router-link
                v-for="child in item.childs"
                :key="child.id"
                :to="child.path"
                class="menu-item"
              >
              <div class="menu-item-content">
                <span class="icon"><i :class="child.icon"></i></span>
                <span class="text">{{ child.name  }}</span>
              </div>
              </router-link>
            </b-collapse>
          </Component>
          </div>
        </div>
      </div>

      <div v-if="settingsItem" class="admin-menu-content">
        <li class="menu-item" ref="submenuButton">
          <div class="menu-item-content">
            <span class="icon"><i :class="settingsItem.icon" /></span>
            <span class="text">{{ settingsItem.name }}</span>
          </div>
        </li>
        <div class="submenu" ref="submenu">
          <div class="scrollable">
            <router-link
              v-for="item of settingsItem.childs"
              :key="item.index"
              class="menu-item"
              :to="item.path"
            >
              <div class="menu-item-content">
                <span class="icon"><i :class="item.icon" /></span>
                <span class="text">{{ item.name }}</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </template>
    <LmLoading v-else color="#ffffffb9" style="height: calc(100vh - 70px)" />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters, mapActions } from 'vuex'

export default defineComponent({
  props: {
    expanded: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters('settings', [
      'menuItems',
      'settingsItem'
    ])
  },
  watch: {
    expanded (val) {
      if (val) {
        this.$root.$emit('bv::hide::popover')
        if (innerWidth < 960) {
          const overlay = document.createElement('div')
          document.body.appendChild(overlay)
          overlay.id = 'overlay'
          overlay.style.position = 'fixed'
          overlay.style.top = 0
          overlay.style.bottom = 0
          overlay.style.left = 0
          overlay.style.right = 0
          overlay.style.zIndex = 4000
          overlay.style.backgroundColor = 'rgba(0, 0, 0, .5)'
          this.$refs.sidebarMenu.style.position = 'fixed'
          this.$refs.sidebarMenu.style.zIndex = 10
          overlay.addEventListener('click', () => {
            this.$parent.expanded = false
          })
        } else {
          this.$refs.sidebarMenu.style.position = 'fixed'
        }
      } else {
        if (innerWidth < 960) {
          const overlay = document.getElementById('overlay')
          if (overlay) {
            overlay.remove()
          }
          if (this.$refs.submenu) {
            this.$refs.submenu.classList.remove('visible')
          }
        }
      }
    },
    '$route.path': {
      immediate: true,
      handler () {
        if (innerWidth < 960) {
          this.$parent.expanded = false
          if (this.$refs.submenu) {
            this.$refs.submenu.classList.remove('visible')
          }
        } else {
          if (this.$refs.submenu) {
            this.$refs.submenu.classList.remove('visible')
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('settings', ['getMainMenuSettings']),
    changeSubMenuPosition () {
      const submenu = this.$refs.submenu
      const button = this.$refs.submenuButton
      if (button === undefined || submenu === undefined) return
      const target = button.getBoundingClientRect()
      submenu.style.position = 'fixed'
      submenu.style.bottom = 43 + 'px'
      submenu.style.width = '244px'
      submenu.style.border = 'none'
      submenu.style.zIndex = '9000'
      if (innerWidth < 600) {
        submenu.style.bottom = 70 + 'px'
        submenu.style.left = '10px'
        submenu.style.border = '1px solid #ffffffb9'
        submenu.style.width = 'calc(100vw - 20px)'
      } else if (innerWidth < 960) {
        submenu.style.bottom = 70 + 'px'
        submenu.style.left = '10px'
        submenu.style.border = '1px solid #ffffffb9'
        submenu.style.width = 'calc(60vw - 20px)'
      } else {
        // this.$parent.expanded = true
        submenu.style.left = target.right + target.left + 5 + 'px'
      }
    },
    setupMenu () {
      const submenu = this.$refs.submenu
      const button = this.$refs.submenuButton
      const sidebarMenu = this.$refs.sidebarMenu

      new ResizeObserver(() => {
        this.changeSubMenuPosition()
      }).observe(sidebarMenu)

      if (button) {
        button.addEventListener('click', () => {
          this.changeSubMenuPosition()
          submenu.classList.toggle('visible')
        })
      }
    },
    popoverConfig (item) {
      return {
        placement: 'right',
        boundary: 'viewport',
        content: item.name,
        disabled: this.expanded,
        customClass: 'ml-4'
      }
    },
    onItemClicked (item) {
      if (item.parent && !this.expanded) {
        this.$parent.expanded = true
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      await this.getMainMenuSettings()
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
      this.$nextTick(() => this.setupMenu())
    }
  },
  mounted () {
    if (process.env.VUE_APP_SOCKET_ENABLED === 'yes') {
      this.sockets.subscribe('menuUpdated', (data) => {
        this.getMainMenuSettings()
      })
    }
    window.addEventListener('resize', () => {
      this.changeSubMenuPosition()
      if (innerWidth < 960) {
        this.$parent.expanded = false
      } else {
        this.$parent.expanded = true
      }
    })
    window.addEventListener('click', (e) => {
      if (
        !e.target.closest('.menu-item') &&
        !e.target.closest('.submenu') &&
        !e.target.closest('.menu-toggle-button')
      ) {
        if (this.$refs.submenu) {
          this.$refs.submenu.classList.remove('visible')
        }
      }
    })
  }
})
</script>

<style scoped>
  #lm-menu {
    height: 100vh;
    align-items: stretch;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 250px;
    background-color: var(--app-accent-color);
    transition: ease-in-out all .25s;
    padding-top: 0px;
    position: fixed;
    top:0;
    z-index: 1000;
  }
  #lm-menu.collapsed {
    width: 82px;
  }
  .menu-label{
    color: #fff;
    margin-left: 11px;
    opacity: 0.8;
    font-weight: bold;
    margin-bottom: 2px;
  }
  i{
    font-size: 20px;
  }
  .submenu {
    z-index: 100;
    border-radius: 12px;
    background-color: var(--app-accent-color);
    padding: 10px;
    color: #ffffffb9;
    width: 250px;
    position: fixed;
    margin-right: 10px;
    margin-left: -30px;
    opacity: 0;
    visibility: hidden;
    transition: cubic-bezier(0.230, 1.000, 0.320, 1.000) all .20s;
  }
  .submenu > .scrollable {
    max-height: 79vh;
  }
  .scrollable {
    padding-right: 0px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .scrollable::-webkit-scrollbar {
    width: 4px;
  }
  .scrollable::-webkit-scrollbar-track {
    background: var(--app-accent-color);
  }
  .scrollable::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background: #ffffffb9;
  }
  .scrollable::-webkit-scrollbar-thumb:hover {
    background: whitesmoke;
  }
  .submenu.visible {
    visibility: visible;
    opacity: 100;
    transform: translateX(30px)
  }
  .menu-content, .admin-menu-content {
    border-top: 0px solid #ffffffb9;
    background-color: var(--app-accent-color);
    padding: 10px;
    display: flex;
    flex-direction: column;
    font-size: .85rem;
    margin: 0;
    margin-bottom: 37px;
  }
  .admin-menu-content > .menu-item {
    margin: 0;
  }
  .menu-content {
    height: calc(100% - 67px );
  }
  .menu-item {
    display: block;
    color: #ffffffb9;
    cursor: pointer;
    padding: 6px 10px;
    margin: 0 0 3px 0;
    border-radius: 6px;
    transition: ease-in-out all .25s;
    display: flex;
    align-items: center;
    /* margin-right: 10px; */
    /* background: #000; */
  }
  .submenu .menu-item {
    margin-right: 10px;
    margin: 0 0 2px 0;
  }
  .menu-item:first-child {
    margin-top: 0;
  }
  .menu-item:last-child {
    margin-bottom: 0;
  }
  .menu-item:hover {
    background-color: #ffffff1c;
  }
  .menu-item.parent .children-menu-items {
    margin: 8px 0;
    margin-left: 6px;
    border-left: 1px solid #ffffffb9
  }
  .menu-item.parent .menu-item {
    background-color: transparent;
  }
  .menu-item-content {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .menu-item-content .icon i {
    display: inline-block;
    margin-bottom: 0px;
  }
  .menu-item-content .text {
    padding-top: 4px;
  }

  #lm-logo {
    /* position: absolute; */
    background: transparent;
    /* margin-bottom: 48px; */
    opacity: 1 !important;
    display: block !important;
  }

  #lm-logo.collapsed {
    opacity: 0;
    margin: -1px 0;
    display: none !important;
  }

  #lm-logo-fav {
    background: transparent;
    transition: ease-in-out all 0.3s;
    display: flex;
    display: none !important;
    justify-content: center;
  }
  #lm-logo-fav img{
    width: 30px;
  }

  #lm-logo-fav.collapsed {
    display: flex !important;
    animation-name: LogoFav;
    animation-duration: 0.6s;
  }

  @keyframes LogoFav {
  from {opacity: 0}
  to {opacity: 1;}
  }

  .menu {
    margin-top: 38px;
  }

  .menu.collapsed {
    margin-top: 14px;
  }

  #lm-menu.collapsed .menu-item {
    height: 40px;
    justify-content: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #lm-menu.collapsed .menu-item-content {
    justify-content: center;
  }
  #lm-menu.collapsed .menu-item-content .text {
    display: none;
  }
  #lm-menu.collapsed .submenu .menu-item {
    height: auto;
    justify-content: flex-start;
  }
  #lm-menu .submenu .menu-item-content .text {
    display: block;
  }

  .router-link-exact-active {
    color: whitesmoke;
    background-color: #ffffff1c;
  }

  @media all and (max-width: 960px) {
    #lm-menu {
      width: 60vw
    }
    #lm-menu.collapsed {
      visibility: hidden;
      opacity: 0;
      width: 0;
    }
    .submenu > .scrollable {
      max-height: calc(85vh - 70px);
    }
  }
  @media all and (max-width: 600px) {
    #lm-menu {
      width: 100vw
    }
  }
</style>
